import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook to check session validity and handle redirects
 */
export const useSessionCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("userData");

    if (!token && !userData) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);
};

/**
 * Utility function to handle API errors and session expiration
 */
export const handleApiError = (error, navigate) => {
  const status = error?.response?.status;
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Something went wrong. Please try again.";

  // Handle session expiration
  if (status === 401 || status === 403) {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    if (navigate) {
      navigate("/login", { replace: true });
    } else {
      window.location.href = "/login";
    }
    return "Session expired. Please login again.";
  }

  return message;
};

/**
 * Utility function to check if user is authenticated
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  const userData = localStorage.getItem("userData");
  return !!(token || userData);
};

